module.exports = {
  "name": "sfpm2023",
  "client": "Mobile spot",
  "description": "Mobile app for test",
  "validLangs": ["fr"],
  "version": {
    "mainVersion": "2.0.1",
    "buildVersion": {
      "iOS": "40",
      "android": "40",
      "web": "105"
    }
  },
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "11.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 31,
    "androidSigning": {
      "keyAlias": "mobilespotmom",
      "keyStorePassword": "jee1Uu0Hieloh7ba"
    },
    "app": "app-react",
    "name": {
      "default": "SFPM NANCY_D"
    },
    "id": "com.mobilespot.sfpm.dev",
    "appleTeamId": "2BAP3P29V2",
    "playStoreUrl": ""
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {
    "url": "sfpm2023.ms-dev.mobile-spot.com"
  },
  "customFileUrlScheme": "msfile",
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "branch": "inte/sfpm2023/main",
    "postCommands": ["cd cordova && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "branch": "inte/sfpm2023/main",
    "postCommands": ["cd mobigeo && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "branch": "inte/sfpm2023/main",
    "dest": "mobigeo/mobigeo-customs"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/sfpm2023/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "branch": "inte/sfpm2023/main",
    "dest": "app-react/app-customs",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};